// components/industry-templates/WeddingEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heart, Camera, Music, Users } from 'lucide-react';

export const WeddingEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-rose-400/20 to-pink-400/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Heart className="w-8 h-8" style={{ color: theme.primary }} />
            Wedding Details
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {industryData?.couple_names && (
              <div className="text-center p-6 bg-white/10 rounded-xl">
                <p className="text-4xl font-bold text-white mb-2">
                  {industryData.couple_names.bride} & {industryData.couple_names.groom}
                </p>
                <p className="text-slate-300">invite you to celebrate their special day</p>
              </div>
            )}
            
            <div className="grid grid-cols-3 gap-4">
              {industryData?.ceremony_time && (
                <div className="p-4 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">💒</div>
                  <p className="text-white font-bold">Ceremony</p>
                  <p className="text-sm text-slate-400">{industryData.ceremony_time}</p>
                </div>
              )}
              {industryData?.reception_time && (
                <div className="p-4 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">🎉</div>
                  <p className="text-white font-bold">Reception</p>
                  <p className="text-sm text-slate-400">{industryData.reception_time}</p>
                </div>
              )}
              {industryData?.guest_count && (
                <div className="p-4 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">👥</div>
                  <p className="text-white font-bold">{industryData.guest_count}</p>
                  <p className="text-sm text-slate-400">Guests</p>
                </div>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {industryData?.vendors && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Wedding Services</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.vendors.photography && (
                <div className="p-4 bg-white/5 rounded-lg">
                  <Camera className="w-6 h-6 mb-2" style={{ color: theme.primary }} />
                  <p className="text-white font-bold">Photography</p>
                  <p className="text-sm text-slate-400">{industryData.vendors.photography}</p>
                </div>
              )}
              {industryData.vendors.music && (
                <div className="p-4 bg-white/5 rounded-lg">
                  <Music className="w-6 h-6 mb-2" style={{ color: theme.primary }} />
                  <p className="text-white font-bold">Music & DJ</p>
                  <p className="text-sm text-slate-400">{industryData.vendors.music}</p>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {industryData?.dress_code && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Dress Code</CardTitle>
          </CardHeader>
          <CardContent>
            <Badge style={{ backgroundColor: theme.primary }} className="text-lg py-3 px-6">
              {industryData.dress_code}
            </Badge>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
